import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../../Icons'

const ACTIVATED_CARDS = ['external', 'services']

const SelectRewardType = ({ amenityActive, onClose = () => {}, setCurrentView = () => {} }) => {
  const { t } = useTranslation(['rewards-table', 'common'])
  const cardsOptions = [
    {
      name: 'external',
      icon: (
        <Icon
          icon="buy"
          className={'icon-buy'}
          viewBox={'0 0 40 40'}
          svgProps={{ strokeWidth: '0' }}
        />
      ),
      title: t('rewards-table:selectRewardType.externalGiftCards'),
    },
    {
      name: 'services',
      icon: (
        <Icon
          icon="gem"
          className={'icon-gem'}
          viewBox={'0 0 40 40'}
          svgProps={{
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
      ),
      title: t('rewards-table:selectRewardType.services'),
    },
    {
      name: 'amenity',
      icon: (
        <Icon
          icon="homeHeart"
          className={'icon-home-heart'}
          viewBox={'0 0 40 40'}
          svgProps={{
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
      ),
      title: t('rewards-table:selectRewardType.amenity'),
    },
  ]

  return (
    <div>
      <div className="rewards-modal-content" style={{ paddingBottom: !amenityActive ? 20 : 0 }}>
        <div className="rewards-card-items">
          <span className="rewards-card-items__title">
            {t('rewards-table:selectRewardType.description')}
          </span>
          <div className="rewards-card-items__wrapper ">
            {cardsOptions.map((option) => (
              <div
                className={`
                  rewards-card-item
                  ${
                    ACTIVATED_CARDS.includes(option.name)
                      ? 'activated'
                      : amenityActive
                        ? 'selected'
                        : ''
                  }
                `}
                key={option.name}
              >
                {option.icon}
                <span>{option.title}</span>
                {ACTIVATED_CARDS.includes(option.name) ? (
                  <div className="active">{t('rewards-table:selectRewardType.activated')}</div>
                ) : !amenityActive ? (
                  <div className="locked">
                    <Icon
                      icon="padlock"
                      svgProps={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
                      viewBox={'0 0 60 60'}
                    />{' '}
                    {t('rewards-table:selectRewardType.locked')}{' '}
                    <span onClick={() => setCurrentView('info')}>
                      {t('rewards-table:selectRewardType.moreInfo')}
                    </span>
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
      {amenityActive && (
        <div className="rewards-modal-actions">
          <button className="button button-gray" onClick={onClose}>
            {t('common:actions.cancel')}
          </button>
          <button
            className="button button-primary auto-width"
            onClick={() => setCurrentView('amenity')}
          >
            {t('rewards-table:selectRewardType.nextButton')}
          </button>
        </div>
      )}
    </div>
  )
}

SelectRewardType.propTypes = {
  amenityActive: PropTypes.bool,
  onClose: PropTypes.func,
  setCurrentView: PropTypes.func,
}

export default SelectRewardType
